

import { useNavigate } from "react-router-dom";
import { IconButton, Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { LayoutTabla } from "../../layout";
import { AlertScreen } from "../components/AlertScreen";

import dayjs from 'dayjs';
import Swal from "sweetalert2"
import { startEstadoCentroCosto } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";






export const TablaCentroCostos = ({ data, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const queryClient = useQueryClient();


    const handleNavigate = (id) => {
        navigate(`/admin/add/${id}/opciones`);
    }



    const cambiarEstadoDoc = (e, d) => {
        e.stopPropagation();
        Swal.fire({
            title: `${d.estado ? 'Bloquear' : 'Desbloquear'} Centro Costo`,
            text: `¿Esta seguro de ${d.estado ? 'Bloquear' : 'Desbloquear'} este centro de costo.?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si, ${d.estado ? 'Bloquear' : 'Desbloquear'}` 
        }).then( async( result ) => {
            if(result.value){
                const resp = await startEstadoCentroCosto(d._id)
                if(resp){
                    queryClient.invalidateQueries({queryKey: ['list-cencos']});
                }
            }
        });
    }




    
    return (

        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(50 / 50)} disabled={Math.ceil(50 / 50) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'10%'}}>A.</TableCell>
                        <TableCell sx={{width:'30%'}}>Fecha Creación</TableCell>
                        <TableCell sx={{width:'60%'}}>Nombre</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (d) => (
                        <TableRow key={d._id} sx={{cursor:'pointer'}} onClick={() => handleNavigate(d._id)}> 
                            <TableCell onClick={(e) => cambiarEstadoDoc(e, d)}>
                                {(d.estado)
                                ?   <IconButton className='boton-estado trru'/>
                                :   <IconButton className='boton-estado fall'/>
                                }
                            </TableCell>
                            <TableCell >{ dayjs(d.fechaCreacion || d.createdAt).format('DD MMM YYYY').toUpperCase() }</TableCell>
                            <TableCell >{ d.nombre }</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        : <AlertScreen title="No hay centros de costo por el momento..." />
        }
        </>
    )
}
